import React from 'react';
import {
    Grid,
    Typography,
} from "@mui/material";


const Summary = (props) => {
    const { item, name } = props
    return (
        <Grid style={{ width: '100%' }}>
            {name === 'service' ?
                (<div style={{

                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gap: '215px',
                }}>
                    <div style={{ display: 'flex' }}>
                        <img className="icon"
                            src={item.icon}
                            alt="link"
                        />
                        <Typography style={{ color: '#000000', fontfamily: 'Rubik', fontWeight: 'Regular', fontSize: '16px', marginTop: '4px', marginLeft: '9%', letterSpacing: '0.1px' }}>{item.Username}</Typography>
<Typography style={{marginTop:'4px',marginLeft:'7px'}}>{item.Lastname}</Typography>
                    </div>
                    {name === 'service' ? (
                        <Grid style={{
                            marginLeft: '2%',

                            backgroundColor: item.status === "submitted"
                                ? "#FFFFFF"
                                : item.status === "Rejected"
                                    ? "#F7E5E8" : item.status === "On Hold" ? "#F6D6A9" : item.status === "Approved" ? "#B2E1BE" : '#C8C8C8'



                            , display: 'flex', justifyContent: 'center', alignItems:'center'
                        }}>
                            <Typography style={{ color: '#000000', fontfamily: 'Rubik', fontWeight: '400', fontSize: '14px', letterSpacing: '0.1px' }}>{item.status}</Typography>
                        </Grid>)

                        : (
                            <Grid>

                                <Typography style={{ color: '#000000', fontfamily: 'Rubik', fontWeight: '400', fontSize: '16px', marginTop: '4px' }}>{item.Mobilenumber}</Typography>
                            </Grid>)

                    }
                    <Grid style={{}}>
                        <Typography style={{ color: '#000000', fontfamily: 'Rubik', fontWeight: 'Regular', fontSize: '16px', marginTop: '4px' }}>{item.email}</Typography>
                    </Grid>
                </div>) : (
                    <Grid
                        sx={{ display: 'flex' }}

                    >
                        <img className="icon"
                            src={item.icon}
                            alt="link"
                        />

                        <div style={{ width: '6%', marginLeft: '1.5%' }}>
                            <Typography style={{ color: '#000000', fontfamily: 'Rubik', fontWeight: 'Regular', fontSize: '16px', marginTop: '4px', letterSpacing: '0.1px' }}>{item.Username}  </Typography>

                        </div>
<Typography style={{width:'18%',marginTop:'4px',color: '#000000', fontfamily: 'Rubik', fontWeight: 'Regular', fontSize: '16px', letterSpacing: '0.1px'}}> {item.Lastname}</Typography>
                        <Grid sx={{ marginLeft: '4%', width: '30%' }}>
                            <Typography style={{ color: '#000000', fontfamily: 'Rubik', fontWeight: '400', fontSize: '16px', marginTop: '4px' }}>{item.Mobilenumber}</Typography>
                        </Grid>
                        <Grid style={{ marginLeft: '6%' }}>
                            <Typography style={{ color: '#000000', fontfamily: 'Rubik', fontWeight: 'Regular', fontSize: '16px', marginTop: '4px' }}>{item.email}</Typography>
                        </Grid>
                    </Grid>

                )
            }

        </Grid>

    )
}

export default Summary;